import { useState } from "react";
import { AdminQuizzesSection, AdminQuestionsSection } from "@/pages/Admin";

const SUB = [
    { key: "quizzes", label: "Quizzes", Comp: AdminQuizzesSection },
    { key: "questions", label: "Questions", Comp: AdminQuestionsSection },
];

export default function AdminQuizzesPage() {
    const [s, setS] = useState("quizzes");
    const Active = SUB.find((x) => x.key === s)?.Comp;
    return (
        <div className="space-y-6" data-testid="admin-quizzes-page">
            <div className="flex gap-2 flex-wrap">
                {SUB.map((x) => (
                    <button key={x.key} onClick={() => setS(x.key)}
                        data-testid={`admin-quizzes-sub-${x.key}`}
                        className={`px-3 py-1.5 text-xs font-mono uppercase tracking-[0.15em] rounded-sm border transition-colors ${
                            s === x.key ? "bg-haevn-700 text-white border-haevn-700" : "bg-white text-ink-500 border-ink-300 hover:border-haevn-700 hover:text-ink-900"
                        }`}>{x.label}</button>
                ))}
            </div>
            {Active && <Active />}
        </div>
    );
}
